import dayjs from '@/libs/dayjs';
import { alpha, styled } from '@mui/material/styles';
import {
  PickersDay,
  type PickersDayProps
} from '@mui/x-date-pickers/PickersDay';
import type { Dayjs } from 'dayjs';

type Props = PickersDayProps<Dayjs> & {
  isSelected?: boolean;
};

export const Component: React.FC<Props> = ({ isSelected, ...other }) => {
  return (
    <PickersDay {...other} selected={isSelected} aria-selected={isSelected} />
  );
};

/**
 * 選択時は背景色を変更する
 * 日選択時はデフォルトの背景色
 */
export const StyledComponent: React.FC<Props> = styled(Component)(
  ({ isSelected, theme }) => ({
    backgroundColor: isSelected ? theme.palette.primary.main : 'inherit',
    color: isSelected ? theme.palette.primary.contrastText : 'inherit',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.light, 0.4),
      color: theme.palette.primary.contrastText
    },
    '&.Mui-selected': isSelected
      ? {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText
        }
      : {
          backgroundColor: 'inherit',
          color: 'inherit'
        },
    '&.Mui-selected:hover': isSelected
      ? {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.contrastText
        }
      : {
          backgroundColor: 'inherit',
          color: 'inherit'
        }
  })
);

type OuterProps = PickersDayProps<Dayjs> & { dates?: Dayjs[] };

export const SelectedDay: React.FC<OuterProps> = (props: OuterProps) => {
  const { dates = [], day } = props;
  const isSelected =
    !props.outsideCurrentMonth &&
    (dates.length === 0
      ? false
      : dates.length === 1
        ? day.isSame(dates[0], 'date')
        : day.isSameOrAfter(dates[0], 'date') &&
          day.isSameOrBefore(dates[1], 'date'));
  const disabled = day.isBefore(dayjs(), 'day');
  return (
    <StyledComponent {...props} isSelected={isSelected} disabled={disabled} />
  );
};
